import React, { useState, useEffect } from 'react';
import { axios, getAxiosConfig } from '../utils/apiUtils';
import { getLoggedInUser } from '../utils/authUtils';
import styles from './faq.module.css';
import logo from '../assets/images/logo_sin_hagamos_cosas_juntos.png';
import { Redirect } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import fbLogo from '../assets/images/fb.svg';
import igLogo from '../assets/images/ig.svg';
import unicefLogo from '../assets/images/mini-logo-unicef-blanco.png';


function debounce(fn, ms) {
  let timer
  return _ => {
    clearTimeout(timer)
    timer = setTimeout(_ => {
      timer = null
      fn.apply(this, arguments)
    }, ms)
  };
}


const FAQ = () => {

  const { t, i18n } = useTranslation();
  const [isCompressed, setIsCompressed] = useState();
  const [goToSeasons, setGoToSeasons] = useState();

  useEffect(() => {
    const debouncedHandleResize = debounce(function handleResize() {
      if (window.scrollY > 20) {
        setIsCompressed(true);
      } else {
        setIsCompressed(false);
      }
    }, 100)

    window.addEventListener('scroll', debouncedHandleResize)

    return _ => {
      window.removeEventListener('scroll', debouncedHandleResize)
    }
  });

  const registerExpressLoginEvent = () => {
    axios.post(
      `${process.env.REACT_APP_API_URL}/auth/express_login`,
      {},
      getAxiosConfig(),
    )
      .then(() => console.log('Express login...'))
      .catch(() => console.error('Failed express login event registering!'));
      setGoToSeasons(true);
  }

  if (goToSeasons) {
    return (<Redirect to="/seasons" />);
  }

  return (
    <div className={`${styles.landingHTML} ${styles.bodyFAQ}`}>

      <header className={`fixed-top ${styles.navbarChungungo}`}>
        <nav className={`navbar navbar-expand navbar-light bg-light ${styles.navChungungo} ${isCompressed ? styles.navbarCompressed : ''}`} aria-label="Eighth navbar example">
          <div className={`container d-flex flex-column flex-lg-row ${styles.navContainer}`}>
            <a className="navbar-brand" href="/">
              <img style={{width: '100%'}} src={logo} alt="Chungungo" />
            </a>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarChungungo"
              aria-controls="navbarChungungo" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>

            <div className={`collapse navbar-collapse`}>
              <ul className="navbar-nav ml-lg-auto">
                <li className={`nav-item ${styles.loginBtn}`}>
                  {getLoggedInUser() &&
                    <Button variant='invisible' className={`nav-link ${styles.loginButton}`} onClick={() => registerExpressLoginEvent()}>Entrar</Button>
                  }
                  {!getLoggedInUser() &&
                    <a className={`nav-link ${styles.loginButton}`} href="/login">Entrar</a>
                  }
                </li>
                <li className="nav-item">
                  <a className={`nav-link btn btn-primary fw-bold ml-3 ${styles.registerBtn} ${styles.orangeBtn}`} href="/register">Crea tu cuenta</a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </header>

      <section className={`container ${styles.contenido}`}>

        <div className="row">
          <div className="col-11 col-md-9 mx-auto">

            <nav aria-label="breadcrumb">
              <ol className={`${styles.breadcrumb} mb-4`}>
                <li className={`${styles.breadcrumbItem}`}><a href="index.html">Inicio</a></li>
                <li className={`${styles.breadcrumbItem} active`} aria-current="page">Preguntas Frecuentes</li>
              </ol>
            </nav>

            <h2>Preguntas Frecuentes</h2>
            <h3>1- ¿Qué es Chungungo?</h3>
            <p>Es una plataforma de suscripción que ofrece contenidos especialmente diseñados para niños de entre 2 a 6 años. Un catálogo de videos experiencias para que mamás, papás o cuidadores hagan cosas junto a ellas y ellos.</p>
            <h3>2- ¿Dónde puedo ver Chungungo?</h3>
            <p>Dónde quieras y cuándo quieras. Disfruta de Chungungo en tu computador, laptop, smartphone, tablet o cualquier dispositivo con conexión a internet.</p>
            <h3>3- ¿Qué puedo encontrar en Chungungo?</h3>
            <p>Un catálogo de cuentos, cuentos con títeres, canciones, manualidades, conozcamos, juegos de palabras, talleres, y otras experiencias pensadas y diseñadas para que gatillen una experiencia en el mundo físico.</p>
            <h3>4- ¿Cuánto cuesta Chungungo?</h3>
            <p>El plan mensual es de {t('faq.price')}, sin costos adicionales ni contratos que te permite cancelar tu suscripción en el momento que quieras.</p>
            <h3>5- ¿Cómo lo cancelo?</h3>
            <p>Sin contratos ni compromisos, para que puedas disfrutar de Chungungo cuando quieras y cancelarlo sin problemas. Puedes cancelar tu suscripción en dos clic en la sección de Mi Cuenta. </p>
            <h3>6- ¿Con qué frecuencia se actualizan los contenidos?</h3>
            <p>Cada quince días encontrarás una nueva estación con experiencias con un hilo conductor que tienen como eje central un cuento de partida. </p>
            <h3>7- ¿Cuándo usar Chungungo?</h3>
            <p>¡Cuándo quieras! Puedes usarlo una, dos o tres veces a la semana, todos los días o varias veces al día, depende de cada familia. La invitación es a darle el tiempo para vivir momentos significativos con tus niñas y niños. </p>
            <h3>8- ¿Chungungo reemplaza el Jardín Infantil?</h3>
            <p>Chungungo no reemplaza la experiencia de aprendizaje de un jardín infantil, sino que la complementa y extiende. Los videos actividades son diseñados por educadoras y educadores.</p>
            <h3>9- Soy educadora/e ¿Puedo usar Chungungo?</h3>
            <p>Sí, queremos ser una fuente de inspiración, y compartir nuestros contenidos novedosos y de calidad para las niñas y niños de todo Chile. Escríbenos a <a href="mailto:educa@chungungo.com">educa@chungungo.com</a> para más información de los planes y programas para utilizar la plataforma en el aula.</p>
          </div>
        </div>
      </section>

      <footer className={`${styles.footerFAQ}`}>
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <ul className="nav justify-content-center">
                <li className="nav-item">
                  <a className="nav-link" href="/#">Inicio</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/about">Acerca de</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/terms_and_conditions">Términos y Condiciones</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="https://regala.chungungo.com/" target="_blank" rel="noreferrer">¿Quieres regalar Chungungo?</a>
                </li>
              </ul>
              <ul className="nav justify-content-center mb-5">
                <li className="nav-item">
                  <a className="nav-link" href="https://www.facebook.com/somoschungungo" target="_blank" rel="noreferrer"><img src={fbLogo} alt="Facebook" /></a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="https://www.instagram.com/chungungo_com" target="_blank" rel="noreferrer"><img src={igLogo} alt="Instagram" /></a>
                </li>
              </ul>
              <small className="text-muted">Todos los derechos reservados© 2021 Chungungo SPA.</small>
            </div>
          </div>
        </div>
        <div className={`${styles.unicef}`}>
          <img src={unicefLogo} alt="Facebook" />
        </div>
      </footer>

    </div>

  );
}

export default FAQ;